import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from "@mui/material";
import type { FC } from "react";

export const daysOfWeek = ["pn", "wt", "sr", "cz", "pt", "sb", "nd"];

interface DayOfWeekCheckboxProps {
  dayName: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const DayOfWeekCheckbox: FC<DayOfWeekCheckboxProps> = ({ dayName, checked, onChange }) => (
  <FormControlLabel
    key={dayName}
    control={<Checkbox checked={checked} size="small" onChange={(e) => onChange(e.target.checked)} name={dayName} />}
    label={dayName}
  />
);

interface Props {
  selectedDays: boolean[];
  disabled?: boolean;
  onSelectionChange: (selectedDays: boolean[]) => void;
}

const DaysOfWeek: FC<Props> = ({ selectedDays, disabled, onSelectionChange }) => (
  <FormControl disabled={disabled}>
    <FormLabel component="legend">Dni tygodnia</FormLabel>
    <FormGroup sx={{ flexDirection: "row" }}>
      {daysOfWeek.map((dayName, dayIdx) => (
        <DayOfWeekCheckbox
          key={dayName}
          dayName={dayName}
          checked={selectedDays[dayIdx]}
          onChange={(checked) => onSelectionChange(selectedDays.map((sd, idx) => (idx === dayIdx ? checked : sd)))}
        />
      ))}
    </FormGroup>
  </FormControl>
);

export default DaysOfWeek;
